<template>
  <div class="dinA4">
    <img :src="require('@/assets/header.png')" class="mb-12 page__header" />
    <div class="page__container">
      
      <p class="body-1 body-1--bold mb-12">
        {{ $t('PAGE2_P1', { name: clientData.name }) }}
      </p>
      <p class="body-1 mb-12">
        {{ $t('PAGE2_P2') }}
      </p>
      <p class="body-1 mb-12">
        {{ $t('PAGE2_P3') }}
      </p>
      <p class="body-1 mb-12">
        {{ $t('PAGE2_P4') }}
      </p>
      <p class="body-1 mb-8">
        {{ $t('PAGE2_P5') }}
      </p>
      <img :src="require('@/assets/firma.png')" class="director-signature" />
      <p class="body-1 mb-0">
        {{ $t('PAGE2_DIRECTOR_NAME') }}
      </p>
      <p class="body-2 mb-12">
        {{ $t('PAGE2_DIRECTOR_JOB') }}
      </p>
      <div class="d-flex justify-end mt-12 body-1">MADRID, {{ date }}</div>
      <div class="commercial-name">
        <p class="body-1"><span class="body-1--bold">{{ $t('PAGE2_COMMERCIAL') }}</span>{{ commercialName }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'

export default {
  name: 'Letter',
  data() {
    return {}
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    commercialName() {
      return this[GET_OFFER_ITEM]('commercial')
    },
    clientData() {
      return this[GET_OFFER_ITEM]('client')
    },
    date() {
      let f = new Date()
      return 'a ' + f.getDate() + '/' + (Number(f.getMonth()) + 1) + '/' + f.getFullYear()
    },
  },
}
</script>

<style scoped lang="scss">
  .commercial-name {
    width: fit-content;
    position: relative;
    top: 1mm;
    padding: 1px;
    padding-top: 0px;
    border-style: solid;
    border-width: 1px;
    border-color: #cccccc;
  }
</style>
